import { SelectItem } from '../components/inputs/SelectInput';

export const emptyMessageTemplate: MessageTemplate = {
  id: '',
  name: '',
  description: '',
  rate: 0,
  client: '',
  type: '',
  category: '',
  userId: '',
  campaignId: '',
  createdDate: 0
};

export interface MessageTemplate {
  id: string;
  name: string;
  description: string;
  rate: number;
  client: string; // homewise
  type: string; // response | campaign
  category: string; // restaurant 
  userId: string;
  campaignId: string;
  createdDate: number;
}

export enum MessageTemplateClients {
  galilaio="galilaio",
  homewize="homewize"
}


export const emptyMessageGroup = {
  id: '',
  campaignId: '',
  contactId: '',
  toPhoneNumber: '',
  fromPhoneNumber: '',
  groupStatus: '',
  count: 0,
  createdDate: 0
}

export interface MessageGroup {
  id: string;
  campaignId: string;
  contactId: string;
  toPhoneNumber: string;
  fromPhoneNumber: string;
  groupStatus: string;
  count: number;
  createdDate: number;
}

export const emptyMessage = {
  id: '',
  groupId: '',
  messageId: '',
  fromPhoneNumber: '',
  toPhoneNumber: '',
  message: '',
  createdDate: 0
}

export interface Message {
  id: string;
  groupId: string;
  messageId: string;
  fromPhoneNumber: string;
  toPhoneNumber: string;
  message: string;
  createdDate: number;
}

export const emptyMessageReceipt = {
  ApiVersion: '',
  Body: '',
  DateSent: '',
  From: '',
  MessagePrice: '',
  MessageSid: '',
  Status: '',
  To: '',
  UseType: ''
}

export interface MessageReceipt {
  ApiVersion: string;
  Body: string;
  DateSent: string;
  From: string;
  MessagePrice: string;
  MessageSid: string;
  Status: string;
  To: string;
  UseType: string;
}

export enum LinkType {
  campaign,
  marketing
}

export interface Link {
  id: string;
  domain: string;
  redirect: string;
  title: string;
  typeId: string;
  type: string;
  contactId: string;
  shortLink: string;
  createdDate: number;
}

export const templateTypes: SelectItem[] = [
  {
    name: "Campaign",
    value: "campaign",
  },
  {
    name: "Response",
    value: "response",
  },
];


// WEBPACK FOOTER //
// ./src/entities/notification.ts